<template>
  <article class="pp-product">
    <div class="pp-product__preamble">
      <p class="pp-product__taxonomy taxonomy-link">{{ productContents[0].product.venue.venue }}</p>
      <p class="pp-event__sponsor" v-if="getSponsor">{{ getSponsor }}</p>
      <h2 class="pp-product__title">{{ productContents[0].product.productName.productName }}</h2>
      <p class="pp-product__date">{{ eventTime(productContents[0].product.productDate) }}</p>
    </div>
    <table class="pp-table pp-table--shopping-cart-product pp-product__shopping-cart-items">
      <tr class="shopping-cart-item shopping-cart-item--header">
        <th class="shopping-cart-item__value shopping-cart-item__value--title-wrapper">
          <span class="shopping-cart-item__th-title">{{ $t('payment.ticket_details') }}</span>
        </th>
        <th class="shopping-cart-item__value shopping-cart-item__value--quantity">
          <span class="shopping-cart-item__th-title">{{ $t('payment.quantity') }}</span>
        </th>
        <th class="shopping-cart-item__value shopping-cart-item__value--unit-price">
          <span class="shopping-cart-item__th-title">{{ $t('payment.unit_price') }}</span>
        </th>
        <th class="shopping-cart-item__value shopping-cart-item__value--booking-fee">
          <span class="shopping-cart-item__th-title">{{ $t('payment.booking_fee') }}</span>
        </th>
        <th class="shopping-cart-item__value shopping-cart-item__value--total-price">
          <span class="shopping-cart-item__th-title">{{ $t('payment.subtotal') }}</span>
        </th>
      </tr>
      <shopping-cart-item :itemInfo="item"
        @confirmDeletion="confirmDeletion($event)"
        v-for="(item, index) in productContents"
        :key="index"/>
      <div class="add-tickets--link" v-if="showAddTicketsLink">
        <a class="btn btn--secondary"
          :href="productUrl"
          :aria-label="$t('buttons.add_link_text')">{{ $t("buttons.add_link_text") }}</a>
      </div>
    </table>
  </article>
</template>

<script>
import moment from "moment-timezone";
import api from "@/util/api";
import ShoppingCartItem from "@/components/shopping-cart/ShoppingCartItem";
import { mapState, mapActions } from "vuex"
import _ from "lodash"

export default {
  name: "shopping-cart-product",
  components: {
    ShoppingCartItem,
  },
  data() {
    return {
      productUrl: "",
      sponsor: null
    }
  },
  props: {
    productContents: {
      type: Array,
      required: true
    },
  },
  computed: {
    cartConfirmationPage() {
      return this.$route.name == 'cart-confirmation'
    },
    showAddTicketsLink() {
      return !this.cartConfirmationPage && this.productUrl.length > 0
    },
    getSponsor() {
      // Note this is different than the implementation on choose-date-time; 
      // here we're referencing the productIcc we retrieve (opposed to grabbing icc out of the URL like we can in choose-seat-flow)
      return _.get(this.event.sponsorIccReferences, this.iccCode, null)
    },
    iccCode() {
      let splitProductUrl = this.productUrl.split('/')

      // Return last item in the product URL we retrieve which will be the ICC Code
      return splitProductUrl[splitProductUrl.length - 1]
    },
    ...mapState(['cart', 'event'])
  },
  async mounted() {
    await this.retrieveProductUrl();    
  },
  methods: {
    async retrieveProductUrl() {
      // This isn't perfect - ideally we'd have loading setup as an array as it'll toggle on & off for each product
      try {
        let event = await api.getEventByProduct(this.productContents[0].product.productId);

        let icc = _.get(event, 'data.sisticEvent.internetContentCode')

        if (icc) {
          this.productUrl = "/" + this.$i18n.locale + "/event/" + icc
        } else {
          console.warn("No event found for product id");
        }
      } catch {
        // We already don't show the button if we can't retrieve the URL (per showAddTicketsLink)
        // Anything else? Probably not. 
      }
    },
    confirmDeletion(item) {
      this.$emit('confirmDeletion', item)
    },
    eventTime(unixTime) {
      let momentLocale = "en";

      switch (this.$i18n.locale) {
        case "tc":
          momentLocale = "zh-HK";
        case "sc":
          momentLocale = "zh-CN";
      }

      moment.locale(momentLocale);

      // Times are given to us in local with Hong Kong timezone attached. We always want
      // to display times in local Hong Kong time. If we don't specify it will convert to
      // the users local browser time.
      if (momentLocale == "en") {
        return moment(unixTime).tz("Asia/Hong_Kong").format(
          "ddd, DD MMMM YYYY h:mma"
        );
      } else {
        return moment(unixTime).tz("Asia/Hong_Kong").format(
          "dddd, LL, a h:mm"
        );
      }
    },
    ...mapActions(['updateLoading'])
  },
}
</script>